import { render, staticRenderFns } from "./BusinessProgramsMsrp.vue?vue&type=template&id=bf54ce8e"
import script from "./BusinessProgramsMsrp.vue?vue&type=script&lang=js"
export * from "./BusinessProgramsMsrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports